import {
  InjectionToken,
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { Analytics, getAnalytics } from 'firebase/analytics';
import { getMessaging, Messaging } from 'firebase/messaging';
import { environment } from '@env/environment';

export const FIREBASE_APP = new InjectionToken<FirebaseApp>('firebase-app');
export const FIREBASE_MESSAGING = new InjectionToken<Messaging | null>(
  'firebase-messaging',
);

export function provideFirebase(): EnvironmentProviders {
  const app = initializeApp(environment.firebase);



  let messaging: Messaging | null = null;
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
  } else {
    console.warn(
      'Firebase Messaging no está soportado en este navegador, requiere HTTPS.',
    );
  }

  return makeEnvironmentProviders([
    { provide: FIREBASE_APP, useValue: app },
    { provide: FIREBASE_MESSAGING, useValue: messaging },
  ]);
}
